import {Book} from "../types";
import React, {ReactElement} from "react";
import {PageView} from "./PageView";
import {Swiper, SwiperSlide} from "swiper/react";
import 'swiper/css';
import 'swiper/css/pagination';
import {Autoplay, Pagination} from "swiper/modules";
import {CARD_SHADOW_LARGE} from "@/shared/dimens";
import {Typography} from "@mui/material";
import {StyledBoxRow} from "@/shared/StyledComponents";

export function Preview(props: { book: Book }): ReactElement {
  return <div
    style={{
      width: "100dvw",
      height: "100dvh",
      display: "flex",
      flexDirection: "column",
      background: "#222",
      alignItems: "center",
      justifyContent: "center"
    }}>
    <Swiper
      style={{
        width: "calc(92dvh * 3/2)", maxWidth: "100dvw",
        boxShadow: CARD_SHADOW_LARGE,
        aspectRatio: 3 / 2,
      }}
      // autoplay={{
      //   delay: 1000, // Time between transitions in milliseconds (default 3000)
      //   disableOnInteraction: false, // Continue autoplay even after user interaction (default true)
      // }}
      // pagination={true}
      modules={[Pagination, Autoplay]}>
      {props.book.pages?.map((page, index) => <SwiperSlide>
        <PageView book={props.book} page={props.book.pages[index]} thumbnail={true}/>
      </SwiperSlide>)}
    </Swiper>
    <StyledBoxRow style={{position: "absolute", right: 8, bottom: 8, alignItems: "center", opacity: 0.8}}>
      <Typography variant={"caption"} style={{color: "white"}}>Powered by</Typography>
      <img src={"/images/dentwyze_logotype_w.svg"} style={{height: 20}}/>
    </StyledBoxRow>
  </div>;
}